import React, { useState } from "react";
import DataTable from "./DataTable";
import Select from "react-select";
import { Link } from "react-router-dom";

export default function CardTable({
  heading,
  columns,
  data,
  buttonData,
  categories,
  handleSelect,
  error,
}) {
  const options = categories;
  const [category, setCategory] = useState();
  return (
    <>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div>
            <h1 className="text-d-bg-text text-2xl font-semibold">{heading}</h1>
          </div>
          {options && (
            <div className="max-w-md w-full">
              <div className="flex gap-2 items-center">
                <Select
                  placeholder={"Category"}
                  options={options}
                  onChange={(e) => setCategory(e.value)}
                  className="w-2/3"
                />
                <button
                  onClick={() => {
                    handleSelect(category);
                  }}
                  className="bg-d-cat-btn text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
                >
                  Submit
                </button>
              </div>
            </div>
          )}
          <div className="flex gap-2">
            {buttonData &&
              buttonData.map((data, index) => (
                <Link
                  className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                  type="button"
                  to={data.path}
                  key={index}
                >
                  {data.buttonText}
                </Link>
              ))}
          </div>
        </div>
        {error && (
          <div
            className="flex items-center p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50"
            role="alert"
          >
            <svg
              className="flex-shrink-0 inline w-4 h-4 me-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
            </svg>
            <span className="sr-only">Info</span>
            <div>{error}</div>
          </div>
        )}
        <DataTable columns={columns} data={data} />
      </div>
    </>
  );
}
